<template>
  <section class="d-flex w-100">
    <div class="d-flex flex-column  w-100" id="boxes">
      <div class="d-flex header-emotivi">
        <div class="d-flex align-items-center">
          <h1>{{ offers_total }} offres commerciales</h1>
        </div>
        <div class="flex-grow-1 d-flex justify-content-end align-items-end" style="margin-top:-40px;">
          <m-form-checkbox
            label="Non-actif"
            :name="$Utils.randomstring('filterNotActive')"
            v-model="filterNotActive"
            @input="loadOffers"
          ></m-form-checkbox>
          <m-form-text
            class="ml-3"
            label="Rechercher"
            label-position="top"
            v-model="filterText"
            name="search"
            autocomplete
            @input="loadOffers"
          ></m-form-text>
          <button class="ml-3 btn btn-sm btn-primary color-white" type="button" @click="addOffers">
            <icon name="plus" scale="1" class="mr-2"></icon> Nouveau
          </button>
        </div>
      </div>

      <div class="flex-grow-1 overflow-hidden d-flex w-100">
        <div class="card card-no-margin w-100">
          <m-list-simple
            ref="contactslist"
            :dynamic="true"
            :items="offers"
            item-value="of_id"
            :item-height="30"
            :total="offers_total"
            @itemclick="editOffers"
          >
            <template v-slot:ths="{}">
              <th style="width:40%;" @click="sortItems(['of_name'])">
                <span class="pointer">Désignation</span>
              </th>
              <th class="">
                <span class="pointer">Produits</span>
              </th>
              <th>
                <span class="pointer">Crée le</span>
              </th>
            </template>
            <template v-slot:tds="{ item }">
              <td>
                {{ item.of_name }}
              </td>
              <td>
                <div v-for="(ofpr, index) in item.offersproducts" :key="ofpr.ofpr_id">
                  {{ ofpr.pr_id.pr_name }} <span v-if="index < item.offersproducts.length - 1"> - </span>
                </div>
              </td>
              <td>
                {{ $moment(item.createdAt).format("DD/MM/YYYY HH[H]mm") }}
              </td>
            </template>
          </m-list-simple>
        </div>
      </div>
    </div>
    <offers-win-edit :of_id="itemSelected.of_id" v-model="dialog" @savedWin="loadOffers"></offers-win-edit>
  </section>
</template>

<script>
export default {
  name: "offers",
  components: {},
  data() {
    return {
      offers: [],
      offers_total: 0,
      filterText: "",
      filterNotActive: false,
      sortOrder: "asc",
      sortFields: [],
      itemSelected: {},
      dialog: false
    };
  },
  watch: {},
  async mounted() {
    this.loadOffers();
  },
  computed: {},
  methods: {
    sortItems(fields) {
      if (fields.length && this.sortFields.length && fields[0] == this.sortFields[0]) {
        this.sortOrder = this.sortOrder == "asc" ? "desc" : "asc";
      }
      this.sortFields = fields;
      this.loadOffers();
    },
    async loadOffers() {
      let sort = this.sortFields.reduce((accumulator, field) => {
        if (accumulator) accumulator += ", ";
        accumulator += field + " " + this.sortOrder;
        return accumulator;
      }, "");
      let params = {
        limit: this.patients_limit,
        notactive: this.filterNotActive,
        sort: sort
      };
      if (this.filterText) params.text = this.filterText;
      let response = await this.$axios.get(this.$config.server_url + "/extranet/2.0/offers", { params });
      if (!response || !response.data) return;
      this.offers = response.data.data;
      this.offers_total = response.data.meta.total;
    },
    addOffers() {
      this.$router.push("/offers/-1");
      this.dialog = true;
    },
    editOffers(item) {
      this.itemSelected = item;
      this.$router.push("/offers/" + this.itemSelected.of_id);
      this.dialog = true;
    },
    deleteOffer(offer) {}
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/styles.scss";
.m-form-checkbox {
  margin-bottom: 0;
}
</style>
